function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import whitelistProps from '../../../utils/whitelistProps';
import styles from './ImmersiveHeaderBreadcrumb.module.scss';
import { Link } from 'react-router-dom';
var whitelist = whitelistProps();
export default function ImmersiveHeaderBreadcrumbLink(_ref) {
  var link = _ref.link,
    label = _ref.label,
    title = _ref.title,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    handleClick = _ref.onClick,
    attrs = _objectWithoutProperties(_ref, ["link", "label", "title", "selected", "onClick"]);
  var additionalAttrs = whitelist(attrs);
  return /*#__PURE__*/React.createElement("li", null, selected ? /*#__PURE__*/React.createElement("span", {
    "aria-label": label,
    className: styles.link
  }, title) : /*#__PURE__*/React.createElement(Link, Object.assign({
    to: link,
    "aria-label": label,
    className: styles.link,
    onClick: handleClick
  }, additionalAttrs), title));
}